import type { CustomerStatus, DealStage } from "./api";
import { STATUS_HUE } from "./statusColors";

/** Pipeline columns, in funnel order — mirrors lib/board.ts for the dev board. */
export const STAGE_COLUMNS: { stage: DealStage; label: string }[] = [
  { stage: "lead", label: "Lead" },
  { stage: "contacted", label: "Contacted" },
  { stage: "proposal", label: "Proposal" },
  { stage: "negotiation", label: "Negotiation" },
  { stage: "won", label: "Won" },
  { stage: "lost", label: "Lost" },
];

export const STAGE_COLOR: Record<DealStage, string> = {
  lead: STATUS_HUE.neutral,
  contacted: STATUS_HUE.blue,
  proposal: STATUS_HUE.amber,
  negotiation: STATUS_HUE.purple,
  won: STATUS_HUE.green,
  lost: STATUS_HUE.red,
};

export const CUSTOMER_STATUS_META: Record<
  CustomerStatus,
  { label: string; color: string }
> = {
  lead: { label: "Lead", color: STATUS_HUE.amber },
  active: { label: "Active", color: STATUS_HUE.green },
  inactive: { label: "Inactive", color: STATUS_HUE.neutral },
};

export { fmtMoney } from "./money";
